export interface IBrokersRequest {
    results: IBroker[];
    success: boolean;
}

export interface IBrokerage{
    agent: string;
    agent_code: string;
    id?: string;
    email?: string;
    fsp?: string;
    intercom_id?: string;
    team?: string;
    team_code?: string;
    telephone?: string;
}
export interface IBroker {
    contact?: string;
    contactCode?: string;
    email?: string;
    broker_id: string;
    id: number;
    rsa_id?: string;
    brokerage_id: string;
    brokerages?: IBrokerage;
    brokerage_agent?: string;
    search_code?: string;
    active?: boolean;
    broker_fee_override?: string;
    adviser_name_town?: string;
    telephone?: string;
    treat_as_brokerless: boolean;
    whatsapp_number?: string;
}